import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, ArrowRight, Gift } from 'lucide-react';
import { Button } from './ui/Button';
import { Container } from './ui/Container';
const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/uploads/cES34sjBtDAJteDaKkFSUr/imgi_15_1747183934-Untitled_design_(19).png',
  packshot: 'https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png',
  peaceful: 'https://cdn.magicpatterns.com/uploads/ucyfC3msYKWzV4hpVgap4d/imgi_17_1746975327-4.png'
};
const CHECKOUT_URLS = {
  pack1: 'https://glowliftessence.com/checkouts/cn/hWN7sPVSvMi4zxKTXeJWh34s/en-us?_r=AQABAO7S3Zf1q2EhPhM7vDxCJ0i0aZLrRNWqM759FB5Cpfs&preview_theme_id=150187475134&skip_shop_pay=true',
  pack3: 'https://glowliftessence.com/checkouts/cn/hWN7sPYv7OcF413jxOpAZfuc/en-us?_r=AQABbWvUEFPW3jyRCWMZge-5-WTHq0s69cHBGuv2CIWCbcY&preview_theme_id=150187475134&skip_shop_pay=true',
  pack5: 'https://glowliftessence.com/checkouts/cn/hWN7sPagPT5iYqy5Sx2LdHH8/en-us?_r=AQABaVuEDBBWWXkq_a4TRf2ZdkroI6zL0pfMdyV7YZXk7Ps&preview_theme_id=150187475134&skip_shop_pay=true'
};
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-gradient-to-b from-blue-50 to-white pt-4 pb-16 overflow-hidden" data-id="element-144">
      <Container data-id="element-145">
        {/* Mobile Header Logo */}
        <div className="flex justify-center mb-6 md:hidden" data-id="element-146">
          <img src="https://cdn.magicpatterns.com/uploads/j7d4EdH3Rp1gzCoto8E26y/imgi_1_1746975280-SnoreStop™.png" alt="SnoreStop Logo" className="h-10" data-id="element-147" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-148">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-149">
            {/* Trust Badge */}
            <div className="flex items-center space-x-2 bg-blue-100 w-fit px-3 py-1 rounded-full text-blue-800 text-sm font-semibold" data-id="element-150">
              <div className="flex" data-id="element-151">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 fill-current text-orange-500" data-id="element-152" />)}
              </div>
              <span data-id="element-153">#1 Rated Anti-Snoring Solution</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight" data-id="element-154">
              Sleep Together Again in{' '}
              <span className="text-[#1E40AF]" data-id="element-155">3 Nights</span> Without the
              Snoring That's Destroying Your Relationship
            </h1>

            <p className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-156">
              SnoreStop™ is a simple anti-snoring mouthpiece that reduces loud
              snoring, restores quiet sleep, and saves relationships — starting
              the very first night.
            </p>

            <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-lg" data-id="element-157">
              <p className="text-red-800 font-medium italic" data-id="element-158">
                If your partner is losing sleep because of your snoring… your
                relationship is slowly paying the price.
              </p>
            </div>

            {/* Benefits List */}
            <ul className="space-y-3" data-id="element-159">
              {['Quiet sleep from the first night', 'Noticeable snoring reduction in 1–3 nights', 'Deeper, uninterrupted sleep within 7 days', 'Wake up rested again in one week', 'Sleep in the same bed again without arguments'].map((benefit, index) => <li key={index} className="flex items-start space-x-3" data-id="element-160">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-161">
                    <Check className="w-4 h-4 text-green-600" data-id="element-162" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-163">{benefit}</span>
                </li>)}
            </ul>

            <div className="pt-4 flex flex-col sm:flex-row gap-4" data-id="element-164">
              <Button onClick={scrollToPricing} size="lg" className="w-full sm:w-auto shadow-xl shadow-blue-900/20" data-id="element-165">
                Choose Your Package Below
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-166" />
              </Button>
            </div>

            <div className="flex items-center space-x-4 text-sm text-gray-500 pt-2" data-id="element-167">
              <span className="flex items-center" data-id="element-168">
                <Check className="w-4 h-4 mr-1 text-blue-600" data-id="element-169" /> 60-Day
                Guarantee
              </span>
              <span className="flex items-center" data-id="element-170">
                <Check className="w-4 h-4 mr-1 text-blue-600" data-id="element-171" /> 10,000+ Happy
                Customers
              </span>
            </div>
          </motion.div>

          {/* Right Visual */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-172">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-173">
              <img src={IMAGES.hero} alt="Couple sleeping peacefully" className="w-full h-auto object-cover" data-id="element-174" />
              {/* Floating Badge */}
              <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-3 rounded-lg shadow-lg max-w-[150px]" data-id="element-175">
                <div className="flex text-orange-500 mb-1" data-id="element-176">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 fill-current" data-id="element-177" />)}
                </div>
                <p className="text-xs font-bold text-gray-900" data-id="element-178">
                  "Saved our marriage in 3 days!"
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Mini Bundles (Above Fold) */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-179">
          {/* Bundle 1 */}
          <div className="bg-white rounded-xl shadow-lg p-4 border border-gray-100 flex flex-col items-center text-center hover:border-blue-200 transition-colors" data-id="element-180">
            <h3 className="font-bold text-gray-900" data-id="element-181">1x SnoreStop™</h3>
            <img src={IMAGES.packshot} alt="1 Pack" className="h-24 object-contain my-2" data-id="element-182" />
            <div className="mb-3" data-id="element-183">
              <span className="text-gray-400 line-through text-sm" data-id="element-184">$79</span>
              <span className="text-2xl font-bold text-gray-900 ml-2" data-id="element-185">$49</span>
              <div className="text-green-600 text-xs font-bold bg-green-50 px-2 py-0.5 rounded-full inline-block mt-1" data-id="element-186">
                SAVE 38%
              </div>
            </div>
            <div className="flex items-center justify-center text-xs text-blue-600 font-semibold mb-3" data-id="element-187">
              <Gift className="w-3 h-3 mr-1" data-id="element-188" />
              <span data-id="element-189">+ FREE Sleep Guide</span>
            </div>
            <Button onClick={() => window.location.href = CHECKOUT_URLS.pack1} variant="outline" size="sm" fullWidth data-id="element-190">
              Select Option
            </Button>
          </div>

          {/* Bundle 2 - Best Value */}
          <div className="bg-blue-50 rounded-xl shadow-xl p-4 border-2 border-blue-500 flex flex-col items-center text-center relative transform md:-translate-y-4" data-id="element-191">
            <div className="absolute -top-3 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-192">
              Best Value
            </div>
            <h3 className="font-bold text-gray-900 mt-2" data-id="element-193">3x SnoreStop™</h3>
            <div className="flex justify-center -space-x-4 my-2" data-id="element-194">
              <img src={IMAGES.packshot} alt="Pack" className="h-24 object-contain" data-id="element-195" />
              <img src={IMAGES.packshot} alt="Pack" className="h-24 object-contain" data-id="element-196" />
              <img src={IMAGES.packshot} alt="Pack" className="h-24 object-contain" data-id="element-197" />
            </div>
            <div className="mb-3" data-id="element-198">
              <span className="text-gray-400 line-through text-sm" data-id="element-199">$189</span>
              <span className="text-2xl font-bold text-gray-900 ml-2" data-id="element-200">
                $117
              </span>
              <div className="text-green-600 text-xs font-bold bg-green-100 px-2 py-0.5 rounded-full inline-block mt-1" data-id="element-201">
                SAVE 38%
              </div>
            </div>
            <div className="flex items-center justify-center text-xs text-blue-600 font-semibold mb-3" data-id="element-202">
              <Gift className="w-3 h-3 mr-1" data-id="element-203" />
              <span data-id="element-204">+ FREE Sleep Guide ($19 Value)</span>
            </div>
            <Button onClick={() => window.location.href = CHECKOUT_URLS.pack3} variant="primary" size="sm" fullWidth data-id="element-205">
              Select Option
            </Button>
          </div>

          {/* Bundle 3 */}
          <div className="bg-white rounded-xl shadow-lg p-4 border border-gray-100 flex flex-col items-center text-center hover:border-blue-200 transition-colors" data-id="element-206">
            <h3 className="font-bold text-gray-900" data-id="element-207">5x SnoreStop™</h3>
            <div className="flex justify-center -space-x-6 my-2" data-id="element-208">
              <img src={IMAGES.packshot} alt="Pack" className="h-20 object-contain" data-id="element-209" />
              <img src={IMAGES.packshot} alt="Pack" className="h-20 object-contain" data-id="element-210" />
              <img src={IMAGES.packshot} alt="Pack" className="h-20 object-contain" data-id="element-211" />
              <img src={IMAGES.packshot} alt="Pack" className="h-20 object-contain" data-id="element-212" />
              <img src={IMAGES.packshot} alt="Pack" className="h-20 object-contain" data-id="element-213" />
            </div>
            <div className="mb-3" data-id="element-214">
              <span className="text-gray-400 line-through text-sm" data-id="element-215">$299</span>
              <span className="text-2xl font-bold text-gray-900 ml-2" data-id="element-216">
                $169
              </span>
              <div className="text-green-600 text-xs font-bold bg-green-50 px-2 py-0.5 rounded-full inline-block mt-1" data-id="element-217">
                SAVE 43%
              </div>
            </div>
            <div className="flex items-center justify-center text-xs text-blue-600 font-semibold mb-3" data-id="element-218">
              <Gift className="w-3 h-3 mr-1" data-id="element-219" />
              <span data-id="element-220">+ FREE Sleep Guide ($19 Value)</span>
            </div>
            <Button onClick={() => window.location.href = CHECKOUT_URLS.pack5} variant="outline" size="sm" fullWidth data-id="element-221">
              Select Option
            </Button>
          </div>
        </div>

        {/* Hero Social Proof */}
        <div className="mt-12 flex flex-col items-center justify-center text-center space-y-4" data-id="element-222">
          <div className="flex -space-x-2" data-id="element-223">
            {[1, 2, 3, 4].map(i => <div key={i} className="w-10 h-10 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-224">
                <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover" data-id="element-225" />
              </div>)}
          </div>
          <div className="flex items-center space-x-2" data-id="element-226">
            <div className="flex text-orange-500" data-id="element-227">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-228" />)}
            </div>
            <span className="font-semibold text-gray-900" data-id="element-229">
              Rated 4.8/5 • Trusted by 10,000+ Couples
            </span>
          </div>
        </div>
      </Container>
    </section>;
}